import { javascript } from "@codemirror/lang-javascript";
import { HighlightStyle, syntaxHighlighting } from "@codemirror/language";
import { Compartment, EditorState } from "@codemirror/state";
import { tags } from "@lezer/highlight";
import Alpine from "alpinejs";
import { EditorView, basicSetup } from "codemirror";
import { js } from "./defaultDoc";
import * as themes from "./themes.js";

const themeConfig = new Compartment();

window.Alpine = Alpine;

const myHighlightStyle = HighlightStyle.define([
    { tag: tags.keyword, fontWeight: 600 },
    {
        tag: tags.comment,
        color: "oklch(63.86% 0.015 41.14)",
        fontStyle: "italic",
    },
    { tag: tags.string, color: "oklch(50% 0.017 234.39)", fontStyle: "italic" },
    { tag: tags.punctuation, color: "oklch(61.31% 0.018 46.44)" },
]);

const startState = EditorState.create({
    doc: js,
    extensions: [
        basicSetup,
        javascript(),
        syntaxHighlighting(myHighlightStyle),
        themeConfig.of(themes.mono),
    ],
});

const editor = new EditorView({
    state: startState,
    parent: document.getElementById("editor"),
});

Alpine.data("data", () => ({
    variant: "mono",
    style: "regular",
    weight: "400",
    init() {
        this.$watch("variant", (variant) => {
            editor.dispatch({
                effects: themeConfig.reconfigure(themes[variant]),
            });
        });
    },
}));

Alpine.start();
